// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/" + chunkId + "." + chunkId + "." + {"1332":"6ed4a815","2589":"d6fdf0fb","9103":"b9ea4917","9397":"c815f8a6"}[chunkId] + ".css";
};